export default "__VITE_ASSET__CO$IBQdk__"